export const portfolio = [
    {
        id:1,
        title:"Dukes Website Design",
        img:"ProjectsImages/89af03133232499 (1).png",
        link:"https://www.behance.net/gallery/133232499/Dukes-UI-UX"
    },
    {
        id: 2,
        title: "Complete Food App UI UX Design",
        img: "ProjectsImages/b3d1bd135054153 (1).png",
        link:"https://www.behance.net/gallery/135054153/Food-App-UI-UX-Design"
        
    },
    {
        id: 3,
        title: "Branding & Social Media Design",
        img: "ProjectsImages/f18feb134610195 (2).png",
        link:"https://www.behance.net/gallery/134610195/Branding-and-Social-Media-Design"
    },
    {
        id: 4,
        title: "Packaging Design For CBD Products",
        img: "ProjectsImages/23b671135722285 (3).png",
        link: "https://www.behance.net/gallery/135722285/Packaging-Design-CBD-Products"

    },
    {
        id: 5,
        title: "Branding & Social Media Design",
        img: "ProjectsImages/f18feb134610195 (4).png",
        link: "https://www.behance.net/gallery/134610195/Branding-and-Social-Media-Design"

    },
    {
        id: 6,
        title: "NFT Landing Page UI UX Design",
        img: "ProjectsImages/23b671135722285 (4).png",
        link: "https://www.behance.net/gallery/133233069/NFT-Landing-Pages-UI"
    }
]